import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import PageFeaturedImage from '../components/page-featured-image';

interface PageFeaturedImageProcessorElement extends Element {
  props: Element['props'];
}

const pageFeaturedImage: Processor<PageFeaturedImageProcessorElement> = {
  priority: 10,
  name: 'pageFeaturedImage',
  test: ({ node }) => !!node.props?.className?.includes('wp-block-erom-page-featured-image'),
  processor: ({ node }) => {
    node.component = PageFeaturedImage as ComponentType;

    return node;
  }
};

export default pageFeaturedImage;
